// @flow
import React from 'react';
import i18n from 'app/common/lib/i18n';
import PrettyNumber from 'app/common/react/i18n/PrettyNumber';
import { interpolateNamedTemplate } from 'app/common/lib/react/interpolate';
import { Box, Text } from 'gestalt';

type Props = {|
  pinCount: number,
  placesCount?: number,
  sectionCount?: number,
|};

export default function PinAndSectionCount({ pinCount, placesCount, sectionCount }: Props) {
  const showPinCount = (!!placesCount && pinCount !== 0) || !placesCount;

  return (
    <Box display="flex" direction="column">
      {placesCount ? (
        <Box display="none" smDisplay="flex" overflow="hidden">
          <Text size="sm" inline truncate>
            {interpolateNamedTemplate(
              i18n.ngettext(
                '{{ count }} place',
                '{{ count }} places',
                placesCount,
                'label for n amount of places',
              ),
              {
                count: <PrettyNumber value={placesCount} key="places-count" />,
              },
            )}
          </Text>
        </Box>
      ) : null}

      {sectionCount ? (
        <Box display="none" smDisplay="flex" overflow="hidden">
          <Text size="sm" inline truncate>
            {interpolateNamedTemplate(
              i18n.ngettext(
                '{{ count }} section',
                '{{ count }} sections',
                sectionCount,
                'label for n amount of sections',
              ),
              {
                count: <PrettyNumber value={sectionCount} key="section_count" />,
              },
            )}
          </Text>
        </Box>
      ) : null}

      {showPinCount && (
        <Box overflow="hidden">
          <Text size="sm" truncate>
            {interpolateNamedTemplate(
              i18n.ngettext(
                '{{ count }} Pin',
                '{{ count }} Pins',
                pinCount,
                'label for n amount of pins',
              ),
              {
                count: <PrettyNumber value={pinCount} key="pin_count" />,
              },
            )}
          </Text>
        </Box>
      )}
    </Box>
  );
}
